import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <div className="container py-8">
        <Button
          variant="ghost"
          className="mb-4"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>

        <div className="prose prose-sm md:prose-base lg:prose-lg dark:prose-invert max-w-none">
          <h1>Newsletter Privacy Policy</h1>
          <p>Last updated: {new Date().toLocaleDateString()}</p>

          <h2>1. Data Collection and Usage</h2>
          <p>When you subscribe to our newsletter, we collect:</p>
          <ul>
            <li>Email address (required)</li>
            <li>Name (optional)</li>
            <li>Company information (optional)</li>
            <li>Newsletter preferences</li>
          </ul>

          <h2>2. Data Retention</h2>
          <p>We retain your data:</p>
          <ul>
            <li>While you remain an active subscriber</li>
            <li>For 30 days after unsubscription (for reactivation purposes)</li>
            <li>Until you request deletion</li>
          </ul>

          <h2>3. Your Data Rights</h2>
          <p>Under GDPR and similar regulations, you have the right to:</p>
          <ul>
            <li>Access your personal data</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Withdraw consent at any time</li>
          </ul>

          <h2>4. Data Protection</h2>
          <p>We protect your data through:</p>
          <ul>
            <li>Secure data storage</li>
            <li>Limited staff access</li>
            <li>Regular security audits</li>
            <li>Encryption of sensitive data</li>
          </ul>

          <h2>5. Contact for Privacy Matters</h2>
          <p>For privacy-related inquiries:</p>
          <ul>
            <li>Email: privacy@example.com</li>
            <li>Response time: Within 48 hours</li>
          </ul>

          <h2>6. Legal Basis for Processing</h2>
          <p>We process your data based on:</p>
          <ul>
            <li>Your consent when subscribing</li>
            <li>Legal obligations for data protection</li>
            <li>Legitimate interests in providing our service</li>
          </ul>

          <h2>7. Data Access Requests</h2>
          <p>To request access to your data:</p>
          <ul>
            <li>Use the data access request form in your account settings</li>
            <li>Email privacy@example.com with "Data Access Request" in the subject</li>
            <li>We'll respond within 30 days</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;